import React from "react";
import { Icon } from "@iconify/react";
import background from "../images/footer-bg.png";
import "../css/footer.scss";
const Footer = () => {
  return (
    <div className="Footer">
      <div class="footer-content">
        <div class="grid-box">
          <p class="head">About</p>
          <p class="text1">
            Amplicon Dx Lab is your one stop solution for COVID-19 testing. We
            now offer COVID-19 nasal swab self-collection test kits, in addition
            to on-site testing and COVID-19 management software.
          </p>
        </div>
        <div class="grid-box">
          <p class="head">Services</p>

          <div class="subGrid">
            <div class="box">
              <a
                class="text2"
                href="https://amplicondxlab.com/onsite-covid19-testing.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  className="arrow-icon"
                  icon="ep:arrow-right-bold"
                  color="#1bbde4"
                />
                <span> Onsite Covid-19</span>
              </a>
              <a
                class="text2"
                href="https://amplicondxlab.com/pathogen-testing.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  className="arrow-icon"
                  icon="ep:arrow-right-bold"
                  color="#1bbde4"
                />
                <span> Respiratory Pathogen Testing</span>
              </a>
            </div>
            <div class="box">
              <a
                class="text2"
                href="https://amplicondxlab.com/molecular-utl.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  className="arrow-icon"
                  icon="ep:arrow-right-bold"
                  color="#1bbde4"
                />
                <span> Molecular UTI</span>
              </a>
              <a
                class="text2"
                href="https://amplicondxlab.com/covid19-testing-for-organization.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  className="arrow-icon"
                  icon="ep:arrow-right-bold"
                  color="#1bbde4"
                />
                <span> COVID-19 Testing for Organization</span>
              </a>
            </div>
          </div>
        </div>
        <div class="grid-box">
          <p class="head">Newsletter</p>
          <p class="text1">
            Sign up now to get daily latest news & updates from us
          </p>
          <div class="email">
            <input type="email" placeholder="Email address" />
            <button>
              <Icon
                icon="fluent:arrow-right-16-filled"
                color="#fff"
                width="18"
                height="18"
              />
            </button>
          </div>
        </div>
      </div>
      <p className="copyrigth">© 2021 Amplicon Dx Lab. All Rights Reserved.</p>
    </div>
  );
};
export default Footer;
